export default "__VITE_ASSET__1d363ad7__"